import {
    all,
    put,
    SagaIterator,
    takeEvery,
    takeEveryCompletedRequest,
    takeEveryErrorRequest
} from './core/sagaEffects';
import {
    PasswordTokenRequest,
    RefreshTokenRequest,
    VerifyAccountTokenRequest
} from 'acscp/api/requests';
import { AddSharingToken, RemoveSharingTokens, UpdatePushNotificationChannelSubscriptions } from 'acscp/actions';

/**
 * Trigger push notification subscription update on any change of the authentication "sources"
 * that are used for sending notifications i.e. login status and sharing tokens.
 */
export function* notificationSubscriptionSaga(): SagaIterator {
    yield all([
        // Successful refreshes shouldn't change auth "source" for notifications.
        // However, failed refresh requests mean that the user is logged out fully -
        // make sure not to send any notifications to them
        takeEveryErrorRequest(RefreshTokenRequest, updatePushNotificationSubscriptions),
        takeEveryCompletedRequest(PasswordTokenRequest, updatePushNotificationSubscriptions),
        takeEveryCompletedRequest(VerifyAccountTokenRequest, updatePushNotificationSubscriptions),
        takeEvery(AddSharingToken, updatePushNotificationSubscriptions),
        takeEvery(RemoveSharingTokens, updatePushNotificationSubscriptions),
    ]);
}

function* updatePushNotificationSubscriptions(): SagaIterator {
    yield put(new UpdatePushNotificationChannelSubscriptions());
}
